import { render, staticRenderFns } from "./TestCards.vue?vue&type=template&id=4937be65&scoped=true&"
import script from "./TestCards.vue?vue&type=script&lang=js&"
export * from "./TestCards.vue?vue&type=script&lang=js&"
import style0 from "./TestCards.vue?vue&type=style&index=0&id=4937be65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937be65",
  null
  
)

export default component.exports